import Icon from '@ant-design/icons';

import If from 'global/Common/If';
import { LightningSvg } from 'features/day-trade/components/Icons';
import { LEVERAGE } from 'global/TradingModal/RealTradingModal/types';

import {
  LabelLot,
  LabelWrapper,
  LeverageGroup,
  LeverageItem,
  LeverageTextContent,
  LeverageWrapper,
  Radio,
} from './sell-levarage.styled';

interface SellLeverageOption {
  icon: React.ReactNode;
  value: LEVERAGE;
  label: string;
  lot: number;
}

interface SellLeverageProps {
  dayTradeLot: number;
  regularLot: number;
  isAmend: boolean;
  leverage: LEVERAGE;
  handleChangeLeverage: (value: LEVERAGE) => void;
}

export default function SellLeverage({
  dayTradeLot = 0,
  regularLot = 0,
  isAmend,
  leverage,
  handleChangeLeverage,
}: SellLeverageProps) {
  const { REGULAR, DAY_TRADE } = LEVERAGE;
  const isHidden = regularLot <= 0 || isAmend;

  const isRegularEmpty = (value: LEVERAGE) => value === REGULAR && isHidden;
  const isDayTradeHidden = (value: LEVERAGE) => value === DAY_TRADE && isHidden;

  const SellLeverageOptions: SellLeverageOption[] = [
    {
      icon: <Icon component={LightningSvg} />,
      value: DAY_TRADE,
      label: 'Day Trade',
      lot: dayTradeLot,
    },
    {
      icon: null,
      value: REGULAR,
      label: 'Regular',
      lot: regularLot,
    },
  ];

  return (
    <LeverageWrapper>
      <LeverageGroup value={leverage}>
        {SellLeverageOptions.map(({ icon, value, label, lot }) => {
          if (isRegularEmpty(value)) return null;

          return (
            <LeverageItem
              key={value}
              onClick={() => handleChangeLeverage(value)}
              isSelected={isDayTradeHidden(value)}
            >
              <If condition={!isDayTradeHidden(value)}>
                <Radio value={value} />
              </If>

              <LeverageTextContent onClick={(e) => e.stopPropagation()}>
                <LabelWrapper>
                  <p>{label}</p>
                  {icon}
                </LabelWrapper>

                <LabelLot>
                  <p>{lot} Lot</p>
                </LabelLot>
              </LeverageTextContent>
            </LeverageItem>
          );
        })}
      </LeverageGroup>
    </LeverageWrapper>
  );
}
